import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { logoutSuccess } from "../actions";
import Cookies from "universal-cookie";

const Logout = (props) => {
    const dispatch = useDispatch();
    const cookies = new Cookies();
    useEffect(() => {
        cookies.remove("authToken");
        dispatch(logoutSuccess());
        setTimeout(() => (window.location = `/login`), 500);
    }, []);
    return <></>;
};

export default Logout;
